module.exports = __webpack_public_path__ + "img/img78.0243e7d0.png";